export default { sha: '28d754f452843f3be0549c7017010fcb46bc61c5', buildNumber: 'undefined' }
